import {
  StyledInlineErrorMessage,
  StyledInlineErrorState,
} from './styles';

type InlineErrorStateProps = {
  message: string;
};

export const InlineErrorState = ({ message }: InlineErrorStateProps) => {
  return (
    <StyledInlineErrorState>
      <StyledInlineErrorMessage>{message}</StyledInlineErrorMessage>
    </StyledInlineErrorState>
  );
};
